import formatDate from './format'

const dateValidateWithFormat = dateAsString => {
  const format = 'DD/MM/YYYY'
  return formatDate(dateAsString, format)
}

export default dateValidateWithFormat
